import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { InlineWidget, useCalendlyEventListener } from "react-calendly";
import { IoClose } from "react-icons/io5";

const ContactUs = ({ open, onClose }) => {
  // const [step, setStep] = useState("CALENDLY");

  useCalendlyEventListener({
    onProfilePageViewed: () => console.log("onProfilePageViewed"),
    onDateAndTimeSelected: () => console.log("onDateAndTimeSelected"),
    onEventTypeViewed: () => console.log("onEventTypeViewed"),
    onEventScheduled: (e) => {
      const eventUri = e.data.payload.event.uri;
      const inviteeUri = e.data.payload.invitee.uri;
      console.log("Event:", eventUri);
      console.log("Invitee:", inviteeUri);
      // setTimeout(() => setStep("FORM"), 2000);
    },
    onPageHeightResize: (e) => console.log(e.data.payload.height),
  });

  return (
    <>
      {/* <div
        className={`modal loginForm fade ${open ? "show" : ""}`}
        style={{ display: open ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
        aria-hidden={!open}
      > */}
      <Modal
        className={"loginForm calendly"}
        show={open}
        onHide={onClose}
        size="xl"
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <button
          type="button"
          className="btnClose"
          onClick={onClose}
          aria-label="Close"
        >
          <IoClose size={22} />
        </button>
        {/* {step === "CALENDLY" && ( */}
        <InlineWidget
          url="https://calendly.com/flowlinks-support/30min?hide_gdpr_banner=1"
          // rootElement={document.getElementById("root")}
          // text="Click here to schedule!"
          // textColor="#ffffff"
          // color="#00a2ff"
        />
        {/* )} */}

        {/* <div class="modal-dialog modal-xl modal-dialog-centered"> */}
        {/* {step === "FORM" && (
          <div class="modal-content">
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-7">
                  <div class="pt-xl-5 px-xl-5">
                    <h2 class="text-center mb-2">Special Offer</h2>
                    <h3 class="text-center mb-5">
                      Please fill out the following form for a one-month free trial.
                    </h3>
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="mb-4">
                          <label for="emailid" class="form-label">
                            Name
                          </label>
                          <input
                            type="email"
                            class="form-control"
                            id="emailid"
                            placeholder="name@example.com"
                          />
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="mb-4">
                          <label for="emailid" class="form-label">
                            Phone Number
                          </label>
                          <input
                            type="email"
                            class="form-control"
                            id="emailid"
                            placeholder="name@example.com"
                          />
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="mb-4">
                          <label for="emailid" class="form-label">
                            Email id
                          </label>
                          <input
                            type="email"
                            class="form-control"
                            id="emailid"
                            placeholder="name@example.com"
                          />
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="mb-4">
                          <label for="emailid" class="form-label">
                            Company
                          </label>
                          <input
                            type="email"
                            class="form-control"
                            id="emailid"
                            placeholder="name@example.com"
                          />
                        </div>
                      </div>

                      <div class="col-lg-12">
                        <div class="mb-4">
                          <label for="emailid" class="form-label">
                            Where will you use it?
                          </label>
                          <textarea class="form-control" rows="5" placeholder="Message"></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="mb-4 d-flex justify-content-end gap-4">
                      <button
                        type="button"
                <div class="col-lg-5 bg-white">
                  <img class="img-fluid my-2" src="img/login-AI.png" />
                </div>
              </div>
            </div>
          </div>
        )} */}
      </Modal>
    </>
  );
};

export default ContactUs;
